import { render, staticRenderFns } from "./ClassroomTicketsPage.vue?vue&type=template&id=3f3238f4"
import script from "./ClassroomTicketsPage.vue?vue&type=script&lang=js"
export * from "./ClassroomTicketsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports